import { Collapse } from '@ui/core'
import type { CollapseProps } from '@ui/core'

export default Collapse
export type { CollapseProps }
